import aiMastermindImage from '../assets/ai-mastermind';

// Add Adilo watch URLs to embedUrl (not the whole iframe snippet).
// Leave both embedUrl and src empty until a video is supplied; src supports MP4/WebM.
// Agency recordings only. Never use these as a fallback for Local Dominate.
export const marketingVideos = {
  introduction: { title: "Stop Writing Your Own Marketing: Your Customers' Reviews Are Already Doing It Better Than Your Agency Ever Could", duration: '60–90 seconds', src: '', embedUrl: 'https://adilo.bigcommand.com/watch/CRJU0T3c', summary: 'Put your customers’ words to work.' },
  walkthrough: { title: 'One customer story. Three ways to put it to work.', duration: '3–5 minutes', src: '', embedUrl: 'https://adilo.bigcommand.com/watch/hNGJQwOK', summary: 'Follow customer feedback into a reply, an article, and a social draft, with human approval at each step.' },
  plans: { title: 'Choose your agency partner path', duration: '2–3 minutes', src: '', embedUrl: 'https://adilo.bigcommand.com/watch/rvzj3e4O', summary: 'Compare agency partnership, qualification, and the route to your own branded reputation system.' },
  enterprise: { title: 'Your brand, your agent names, your implementation', duration: '2–3 minutes', src: '', embedUrl: '', summary: 'What is configured, what the agreed scope covers, and how ongoing operations are handled.' },
  onboarding: { title: 'Start with your own location', duration: '2–3 minutes', src: '', embedUrl: '', summary: 'Prepare your business profile, brand voice, access, and first client rollout.' },
};
// Local business recordings are a separate set. Hide empty slots until supplied.
export const localMarketingVideos = {
  introduction: { title: 'Meet Joe Moore — your human guide to RepUpgrade', src: '', embedUrl: '', summary: 'Connect Google and your supported social profiles with Joe during setup. He handles the configuration.' },
  walkthrough: { title: 'How Local Dominate works', src: '', embedUrl: '', summary: 'Connect your business, set your voice, and put your reputation to work.' },
  plans: { title: 'Choose your Local Dominate plan', src: '', embedUrl: '', summary: 'Compare Grow, Amplify, and Complete for your business location.' },
};

export const joePortrait = '/images/joe-moore.jpg';
export const communityLinks = {
  mastermind: 'https://www.digitalcowboy.io/ai-mastermind/',
  events: 'https://www.digitalcowboy.io/events/',
  articles: 'https://www.digitalcowboy.io/blog/',
};







export const mastermindArtwork = {
 src: aiMastermindImage,
 alt: 'AI Mastermind featuring the AIPosse, hosted by Joe Moore with Katrena Drake, Tuesdays at noon Central',
 width: 1600, height: 900,
};